import React, { Component, useRef } from "react";
import { EventBus, EventBusEvents } from "@/store/event-bus.ts";
import Textinput from "@/components/ui/Textinput";
import Textarea from "@/components/ui/Textarea";
import { toast } from "react-toastify";
import { constants } from "@/constants.js";
import { urlChatID } from "@/utils/url.js";

import LoadingSpinner from "@/components/partials/LoadingSpinner.jsx";
import ListTexts from "@/pages/chatbot/sources/ListTexts.jsx";
import { useQueryClient } from "react-query";
import { queryKeyChatbotSummary } from "@/pages/chatbot/sources/ChatBotSources";
import {useTranslation} from "react-i18next";

const ChatBotSourcesText = () => {
  const {t} = useTranslation();
  const queryClient = useQueryClient();

  const [uploading, setUploading] = React.useState(false);
  const [title, setTitle] = React.useState("");
  const [text, setText] = React.useState("");

  const addText = async () => {
    if (!text) {
      toast.error("Empty text field", {
        position: "top-right",
        autoClose: 3000,
        theme: "light",
      });
      return;
    }

    setUploading(true);
    try {
      let res = await fetch(
        `${constants.url.API_PREFIX}chatbot/${urlChatID()}/texts/add`,
        {
          method: "POST",
          body: JSON.stringify({
            title: title,
            text: text,
          }),
        },
      );
      let json = await res.json();
      if (json.error) {
        toast.error(json.error, {
          position: "top-right",
          autoClose: 3000,
          theme: "light",
        });
      } else if (json.message) {
        toast.success(json.message, {
          position: "top-right",
          autoClose: 3000,
          theme: "light",
        });
      }
    } catch (e) {
      toast.error("Text add error", {
        position: "top-right",
        autoClose: 1500,
        theme: "light",
      });
    }
    setUploading(false);
    EventBus.getInstance().dispatch("chatbot.sources.texts.add");
    queryClient.invalidateQueries(queryKeyChatbotSummary);
  };

  return (
    <div>
      <div className="bg-slate-50 p-4 rounded-lg">
        <Textinput
          label={t("title")}
          type="text"
          placeholder=""
          onChange={(e) => {
            setTitle(e.target.value);
          }}
        />

        <div className="mt-4">
          <Textarea
            label={t("content")}
            placeholder=""
            row={10}
            onChange={(e) => {
              setText(e.target.value);
            }}
          />
        </div>

        <div className="mt-6 flex justify-end">
          <button
            type="submit"
            className="btn btn inline-flex justify-center btn-primary btn"
            onClick={addText}
          >
            <span className="flex items-center">
              <span>{uploading ? <LoadingSpinner /> : t("add")}</span>
            </span>
          </button>
        </div>
      </div>

      <ListTexts />
    </div>
  );
};

export default ChatBotSourcesText;
